export interface IProgressBar {
  percentage: number
  icon: string
  title: string
  subtitle: string
  color: string
  description: string
}

export interface ICard {
  bars: IProgressBar[]
  year: number
}

const cards: ICard[] = [
  {
    bars: [
      {
        percentage: 80,
        icon: '/images/mission/dollar.svg',
        // t(`stats:ourProgressNumberTransPerDay`)
        description: 'NumberTransPerDay',
        title: '2 398 881',
        // t(`stats:ourProgressTransactions`)
        subtitle: 'Transactions',
        color: '#23C847',
      },
      {
        percentage: 85,
        icon: '/images/mission/human.svg',
        // t(`stats:ourProgressNumberSignUps`)
        description: 'NumberSignUps',
        title: '3 924 918',
        // t(`stats:ourProgressUsers`)
        subtitle: 'Users',
        color: '#CE6BB2',
      },
    ],
    year: 2022,
  },
  {
    bars: [
      {
        percentage: 70,
        icon: '/images/mission/dollar.svg',
        description: 'NumberTransPerDay',
        title: '1 503 453',
        // t(`stats:ourProgressTransactions`)
        subtitle: 'Transactions',
        color: '#A81717',
      },
      {
        percentage: 75,
        icon: '/images/mission/human.svg',
        // t(`stats:ourProgressNumberSignUps`)
        description: 'NumberSignUps',
        title: '2 252 721',
        // t(`stats:ourProgressUsers`)
        subtitle: 'Users',
        color: '#888DFF',
      },
    ],
    year: 2021,
  },
  {
    bars: [
      {
        percentage: 50,
        icon: '/images/mission/dollar.svg',
        description: 'NumberTransPerDay',
        title: '928 674',
        subtitle: 'Transactions',
        color: '#8E6946',
      },
      {
        percentage: 55,
        icon: '/images/mission/human.svg',
        description: 'NumberSignUps',
        title: '1 864 639',
        subtitle: 'Users',
        color: '#5FCFE8',
      },
    ],
    year: 2020,
  },
  {
    bars: [
      {
        percentage: 30,
        icon: '/images/mission/dollar.svg',
        description: 'NumberTransPerDay',
        title: '123 923',
        subtitle: 'Transactions',
        color: '#9C35ED',
      },
      {
        percentage: 35,
        icon: '/images/mission/human.svg',
        description: 'NumberSignUps',
        title: '120 808',
        subtitle: 'Users',
        color: '#FF3D00',
      },
    ],
    year: 2019,
  },
  {
    bars: [
      {
        percentage: 10,
        icon: '/images/mission/dollar.svg',
        description: 'NumberTransPerDay',
        title: '23 340',
        subtitle: 'Transactions',
        color: '#357FED',
      },
      {
        percentage: 15,
        icon: '/images/mission/human.svg',
        description: 'NumberSignUps',
        title: '54 402',
        subtitle: 'Users',
        color: '#FFA800',
      },
    ],
    year: 2018,
  },
]

export default cards
